import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import customerReducer from "../features/cutomers/customerSlice";
import productReducer from "../features/product/productSlice";
import metalReducer from "../features/metal/metalSlice";
import purityReducer from "../features/purity/puritySlice";
import pCategoryReducer from "../features/pcategory/pcategorySlice";
import bannerReducer from "../features/banner/bannerSlice";
import promoTypeReducer from "../features/promotype/promotypeSlice";
import colorReducer from "../features/color/colorSlice";
import enquiryReducer from "../features/enquiry/enquirySlice";
import couponReducer from "../features/coupon/couponSlice";
import reviewReducer from "../features/reviews/reviewSlice";
import metalRateReducer from "../features/dailymetalrate/dailymetalrateSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import settingsReducer from "../features/settings/settingsSlice";
import customDesignReducer from "../features/customDesign/customDesignSlice";
import productEnquiryReducer from "../features/productEnquiry/productEnquirySlice";
import goldSchemeReducer from "../features/goldScheme/goldSchemeSlice";
import imageFeedReducer from "../features/imageFeed/imageFeedSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    customer: customerReducer,
    product: productReducer,
    metal: metalReducer,
    purity: purityReducer,
    pCategory: pCategoryReducer,
    banner : bannerReducer,
    promoType: promoTypeReducer,
    color: colorReducer,
    review: reviewReducer,
    dashboard: dashboardReducer,
    enquiry: enquiryReducer,
    metalRate: metalRateReducer,
    coupon: couponReducer,
    settings: settingsReducer,
    customDesign: customDesignReducer,
    productEnquiry: productEnquiryReducer,
    goldScheme: goldSchemeReducer,
    imageFeed: imageFeedReducer,
  },
});
